import { store } from './store.js';
// ========================================
// PROBLEM GENERATOR - Multi-Agent Orchestrator + Mock Fallback
// Coordina MathAgent → NarrativeAgent → VisualAgent
// ========================================

// ========================================
// STORY SEQUENCE GENERATOR (CONTINUOUS NARRATIVE)
// ========================================

function getCumpleanosStorySequence(config) {
    const isEnglish = (typeof currentLanguage !== 'undefined' ? currentLanguage : 'es-ES').startsWith('en');

    console.log(`📖 Generando MISIÓN CONTINUA: cumpleaños - Nivel: ${config.level}`);

    let problems = [];

    if (config.level === 'beginner') {
        problems = [
            {
                id: 'cump_beg_1', type: 'sum', paevCategory: 'CB1', contextId: 'cumpleanos', contextColor: '#FF6B9D',
                statement: {
                    'es-ES': 'Para la fiesta compramos 3 globos rojos y 2 globos azules.',
                    'en-GB': 'For the party we bought 3 red balloons and 2 blue balloons.'
                },
                question: isEnglish ? 'How many balloons do we have in total?' : '¿Cuántos globos tenemos en total?',
                data: { useful: [3, 2], distracting: [] },
                solution: { answer: 5, operation: '3 + 2 = 5', operationType: 'sum', explanation: null },
                storyData: { type: 'inicio', objName: 'globos' },
                contextName: { 'es-ES': 'Fiesta (Aprendiz)', 'en-GB': 'Party (Beginner)' }
            },
            {
                id: 'cump_beg_2', type: 'subtraction', paevCategory: 'C2', contextId: 'cumpleanos', contextColor: '#FF6B9D',
                statement: {
                    'es-ES': 'Teníamos 5 globos inflados, pero 1 globo se pinchó.',
                    'en-GB': 'We had 5 inflated balloons, but 1 balloon popped.'
                },
                question: isEnglish ? 'How many balloons are left?' : '¿Cuántos globos quedan?',
                data: { useful: [5, 1], distracting: [] },
                solution: { answer: 4, operation: '5 - 1 = 4', operationType: 'subtraction', explanation: null },
                storyData: { type: 'desarrollo', objName: 'globos' },
                contextName: { 'es-ES': 'Fiesta (Aprendiz)', 'en-GB': 'Party (Beginner)' }
            },
            {
                id: 'cump_beg_3', type: 'sum', paevCategory: 'C1', contextId: 'cumpleanos', contextColor: '#FF6B9D',
                statement: {
                    'es-ES': 'Para jugar, pusimos 4 sillas. Luego llegaron 3 amigos más.',
                    'en-GB': 'To play, we placed 4 chairs. Then 3 more friends arrived.'
                },
                question: isEnglish ? 'How many chairs do we need in total?' : '¿Cuántas sillas necesitamos en total?',
                data: { useful: [4, 3], distracting: [] },
                solution: { answer: 7, operation: '4 + 3 = 7', operationType: 'sum', explanation: null },
                storyData: { type: 'nudo', objName: 'sillas' },
                contextName: { 'es-ES': 'Fiesta (Aprendiz)', 'en-GB': 'Party (Beginner)' }
            },
            {
                id: 'cump_beg_4', type: 'subtraction', paevCategory: 'C2', contextId: 'cumpleanos', contextColor: '#FF6B9D',
                statement: {
                    'es-ES': 'Había 7 caramelos en la mesa, pero el perro se comió 2.',
                    'en-GB': 'There were 7 candies on the table, but the dog ate 2.'
                },
                question: isEnglish ? 'How many candies are left?' : '¿Cuántos caramelos quedan?',
                data: { useful: [7, 2], distracting: [] },
                solution: { answer: 5, operation: '7 - 2 = 5', operationType: 'subtraction', explanation: null },
                storyData: { type: 'desenlace', objName: 'caramelos' },
                contextName: { 'es-ES': 'Fiesta (Aprendiz)', 'en-GB': 'Party (Beginner)' }
            }
        ];
    } else if (config.level === 'advanced') {
        problems = [
            {
                id: 'cump_adv_1', type: 'sum', paevCategory: 'CB1', contextId: 'cumpleanos', contextColor: '#FF6B9D',
                statement: {
                    'es-ES': 'Para decorar, Ana puso 12 guirnaldas y su padre trajo 5 farolillos.',
                    'en-GB': 'To decorate, Ana placed 12 garlands and her father brought 5 lanterns.'
                },
                question: isEnglish ? 'How many decorations are there in total?' : '¿Cuántas decoraciones hay en total?',
                data: { useful: [12, 5], distracting: [] },
                solution: { answer: 17, operation: '12 + 5 = 17', operationType: 'sum', explanation: null },
                storyData: { type: 'inicio', objName: 'decoraciones' },
                contextName: { 'es-ES': 'Fiesta (Avanzado)', 'en-GB': 'Party (Advanced)' }
            },
            {
                id: 'cump_adv_2', type: 'subtraction', paevCategory: 'C2', contextId: 'cumpleanos', contextColor: '#FF6B9D',
                statement: {
                    'es-ES': 'De las 17 decoraciones del jardín, el viento se llevó 4.',
                    'en-GB': 'Of the 17 decorations in the garden, the wind blew away 4.'
                },
                question: isEnglish ? 'How many decorations are left?' : '¿Cuántas decoraciones quedan?',
                data: { useful: [17, 4], distracting: [] },
                solution: { answer: 13, operation: '17 - 4 = 13', operationType: 'subtraction', explanation: null },
                storyData: { type: 'desarrollo', objName: 'decoraciones' },
                contextName: { 'es-ES': 'Fiesta (Avanzado)', 'en-GB': 'Party (Advanced)' }
            },
            {
                id: 'cump_adv_3', type: 'sum', paevCategory: 'C1', contextId: 'cumpleanos', contextColor: '#FF6B9D',
                statement: {
                    'es-ES': 'Teníamos 13 invitados esperando a que empezara la fiesta y llegaron 7 amigos más.',
                    'en-GB': 'We had 13 guests waiting for the party to start and 7 more friends arrived.'
                },
                question: isEnglish ? 'How many guests are there in total?' : '¿Cuántos invitados hay en total?',
                data: { useful: [13, 7], distracting: [] },
                solution: { answer: 20, operation: '13 + 7 = 20', operationType: 'sum', explanation: null },
                storyData: { type: 'nudo', objName: 'invitados' },
                contextName: { 'es-ES': 'Fiesta (Avanzado)', 'en-GB': 'Party (Advanced)' }
            },
            {
                id: 'cump_adv_4', type: 'subtraction', paevCategory: 'C2', contextId: 'cumpleanos', contextColor: '#FF6B9D',
                statement: {
                    'es-ES': 'Entre todos le dieron 20 regalos. Ana ya ha abierto 5 regalos.',
                    'en-GB': 'Between everyone they gave her 20 presents. Ana has already opened 5 presents.'
                },
                question: isEnglish ? 'How many presents are left to open?' : '¿Cuántos regalos le quedan por abrir?',
                data: { useful: [20, 5], distracting: [] },
                solution: { answer: 15, operation: '20 - 5 = 15', operationType: 'subtraction', explanation: null },
                storyData: { type: 'desenlace', objName: 'regalos' },
                contextName: { 'es-ES': 'Fiesta (Avanzado)', 'en-GB': 'Party (Advanced)' }
            }
        ];
    } else {
        problems = [
            {
                id: 'cump_exp_1', type: 'sum', paevCategory: 'CB1', contextId: 'cumpleanos', contextColor: '#FF6B9D',
                statement: {
                    'es-ES': 'La familia de Ana envió 45 invitaciones el lunes y 32 el martes para la mega fiesta.',
                    'en-GB': 'Ana\'s family sent 45 invitations on Monday and 32 on Tuesday for the mega party.'
                },
                question: isEnglish ? 'How many invitations did they send in total?' : '¿Cuántas invitaciones enviaron en total?',
                data: { useful: [45, 32], distracting: [] },
                solution: { answer: 77, operation: '45 + 32 = 77', operationType: 'sum', explanation: null },
                storyData: { type: 'inicio', objName: 'invitaciones' },
                contextName: { 'es-ES': 'Fiesta (Experto)', 'en-GB': 'Party (Expert)' }
            },
            {
                id: 'cump_exp_2', type: 'subtraction', paevCategory: 'C2', contextId: 'cumpleanos', contextColor: '#FF6B9D',
                statement: {
                    'es-ES': 'De los 77 invitados, 12 contestaron que no pueden venir a la fiesta.',
                    'en-GB': 'Of the 77 guests, 12 answered that they cannot come to the party.'
                },
                question: isEnglish ? 'How many guests are coming to the party?' : '¿Cuántos invitados vienen a la fiesta?',
                data: { useful: [77, 12], distracting: [] },
                solution: { answer: 65, operation: '77 - 12 = 65', operationType: 'subtraction', explanation: null },
                storyData: { type: 'desarrollo', objName: 'invitados' },
                contextName: { 'es-ES': 'Fiesta (Experto)', 'en-GB': 'Party (Expert)' }
            },
            {
                id: 'cump_exp_3', type: 'sum', paevCategory: 'C1', contextId: 'cumpleanos', contextColor: '#FF6B9D',
                statement: {
                    'es-ES': 'Compramos 65 refrescos para todos, y un vecino nos regaló 20 refrescos más.',
                    'en-GB': 'We bought 65 sodas for everyone, and a neighbor gave us 20 more sodas.'
                },
                question: isEnglish ? 'How many sodas do we have in total?' : '¿Cuántos refrescos tenemos en total?',
                data: { useful: [65, 20], distracting: [] },
                solution: { answer: 85, operation: '65 + 20 = 85', operationType: 'sum', explanation: null },
                storyData: { type: 'nudo', objName: 'refrescos' },
                contextName: { 'es-ES': 'Fiesta (Experto)', 'en-GB': 'Party (Expert)' }
            },
            {
                id: 'cump_exp_4', type: 'subtraction', paevCategory: 'C2', contextId: 'cumpleanos', contextColor: '#FF6B9D',
                statement: {
                    'es-ES': 'Teníamos 85 refrescos en la nevera, y durante la mañana nos hemos bebido 30.',
                    'en-GB': 'We had 85 sodas in the fridge, and during the morning we have drunk 30.'
                },
                question: isEnglish ? 'How many sodas are left for the party?' : '¿Cuántos refrescos quedan para la fiesta?',
                data: { useful: [85, 30], distracting: [] },
                solution: { answer: 55, operation: '85 - 30 = 55', operationType: 'subtraction', explanation: null },
                storyData: { type: 'desenlace', objName: 'refrescos' },
                contextName: { 'es-ES': 'Fiesta (Experto)', 'en-GB': 'Party (Expert)' }
            }
        ];
    }

    // Shuffle problems to present 2 sum and 2 subtraction in random order
    for (let i = problems.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [problems[i], problems[j]] = [problems[j], problems[i]];
    }

    return problems;
}

// ========================================
// MULTI-AGENT ORCHESTRATOR (FASES 4-6)
// ========================================

/**
 * Genera problemas usando el sistema de 3 agentes (Matemático, Narrativo, Visual)
 * Pipeline: MathAgent → NarrativeAgent → VisualAgent
 * @param {Object} config - Configuración {problemType, level, context}
 * @returns {Promise<Array>} Array de 5 problemas completos con narrativa e imágenes
 */
async function generateProblemsWithAgents(config) {
    console.log('🤖 [Orchestrator] Iniciando sistema multi-agente...');
    console.log('📋 Configuración:', config);

    // INTERCEPTAR PARA CONTINUIDAD NARRATIVA (STORY MODE) - SÓLO PARA NUEVA MISIÓN (ANY)
    if (config.context === 'cumpleanos' && config.problemType === 'any') {
        const story = getCumpleanosStorySequence(config);
        if (story) return story;
    }

    try {
        // FASE 4: AGENTE MATEMÁTICO
        console.log('🧮 [Orchestrator] Fase 4: Invocando Math Agent...');
        const mathStructures = generateMathStructures(config, config.context);

        if (!mathStructures || mathStructures.length === 0) {
            throw new Error('Math Agent no generó estructuras válidas');
        }

        console.log(`✅ [Orchestrator] ${mathStructures.length} estructuras matemáticas generadas`);

        // FASE 5: AGENTE NARRATIVO
        console.log('📖 [Orchestrator] Fase 5: Invocando Narrative Agent...');
        const currentLang = typeof currentLanguage !== 'undefined' ? currentLanguage : 'es-ES';
        const enrichedProblems = await enrichWithNarrative(
            mathStructures,
            config.context,
            config.level,
            currentLang
        );

        console.log(`✅ [Orchestrator] ${enrichedProblems.length} problemas enriquecidos con narrativa`);

        // FASE 6: AGENTE VISUAL
        console.log('🎨 [Orchestrator] Fase 6: Invocando Visual Agent...');
        const finalProblems = await generateImagesForProblems(enrichedProblems);

        const imagesGenerated = finalProblems.filter(p => p.imageUrl !== null).length;
        console.log(`✅ [Orchestrator] ${imagesGenerated}/${finalProblems.length} imágenes generadas`);

        // Formato final compatible con el resto de la app
        let formattedProblems = formatProblemsForApp(finalProblems, config);

        // --- UNIQUE PROBLEM FILTERING ---
        if (window.SessionManager && window.SessionManager.isProblemSolved) {
            const originalCount = formattedProblems.length;
            formattedProblems = formattedProblems.filter(p => !window.SessionManager.isProblemSolved(p.id));
            const filteredCount = formattedProblems.length;

            if (filteredCount < originalCount) {
                console.log(`🧹 Filtered ${originalCount - filteredCount} duplicate problems.`);
            }

            // If we ran out of unique problems, reset the history or use what we have
            if (filteredCount === 0 && originalCount > 0) {
                console.warn('⚠️ All available problems solved! Resetting session history or reusing problems.');
                // Option A: Reset history (simpler for now)
                // store.state.solvedProblemIds = [];
                // formattedProblems = formatProblemsForApp(finalProblems, config);

                // Option B: Allow duplicates if no unique left (better UX than crashing)
                formattedProblems = formatProblemsForApp(finalProblems, config);
            }
        }
        // --------------------------------

        console.log('🎉 [Orchestrator] Pipeline multi-agente completado exitosamente');
        return formattedProblems;

    } catch (error) {
        console.error('❌ [Orchestrator] Error en pipeline:', error);
        console.warn('⚠️ [Orchestrator] Fallback a generación mock...');

        // Fallback completo a generación mock
        return generateProblems(config);
    }
}

/**
 * Formatea problemas generados por agentes al formato esperado por la app
 */
function formatProblemsForApp(agentProblems, config) {
    const context = CONTEXTS.find(ctx => ctx.id === config.context);
    const currentLang = typeof currentLanguage !== 'undefined' ? currentLanguage : 'es-ES';

    return agentProblems.map((problem, index) => ({
        // Unique ID based on content: context_operation_num1_num2
        id: `${config.context}_${convertLogicTypeToAppType(problem.logic_type)}_${problem.operands[0]}_${problem.operands[1]}`,
        type: convertLogicTypeToAppType(problem.logic_type),
        paevCategory: problem.paev_category,
        contextId: config.context,
        contextName: context ? context.title : {},
        contextColor: context ? context.color : '#9C27B0',

        // Narrativa
        statement: {
            'es-ES': problem.story_text,
            [currentLang]: problem.story_text
        },
        question: problem.question || '¿Cuántos en total?',

        // Datos matemáticos
        data: {
            useful: problem.operands,
            distracting: problem.distractors || []
        },

        // Solución
        solution: {
            answer: problem.correct_answer,
            operation: buildOperationString(problem),
            operationType: convertLogicTypeToAppType(problem.logic_type),
            explanation: problem.explanation
        },

        // Imagen generada
        imageUrl: problem.imageUrl || null,
        imagePrompt: problem.image_prompt || null
    }));
}

/**
 * Construye string de operación matemática
 */
function buildOperationString(problem) {
    const [num1, num2] = problem.operands;
    const answer = problem.correct_answer;

    switch (problem.logic_type) {
        case 'suma':
            return `${num1} + ${num2} = ${answer}`;
        case 'resta':
            return `${num1} - ${num2} = ${answer}`;
        default:
            return `${num1} ? ${num2} = ${answer}`;
    }
}

/**
 * Convierte tipo lógico del agente a tipo de la app
 */
function convertLogicTypeToAppType(logicType) {
    const mapping = {
        'suma': 'sum',
        'resta': 'subtraction'
    };
    return mapping[logicType] || 'sum';
}

// CONTEXT OBJECTS MAPPING
// ========================================

// Mapeo de objetos específicos por contexto
// Cada contexto tiene un ARRAY de 6-8 objetos con: singular (es/en), plural (es/en), emoji, gender
// Sistema de variedad: garantiza máximo 9% de repetición del mismo objeto

const CONTEXT_OBJECTS = {
    // 🎈 MOMENTOS ESPECIALES
    'cumpleanos': [
        { singular: { es: 'regalo', en: 'gift' }, plural: { es: 'regalos', en: 'gifts' }, emoji: '🎁', gender: 'm' },
        { singular: { es: 'vela', en: 'candle' }, plural: { es: 'velas', en: 'candles' }, emoji: '🕯️', gender: 'f' },
        { singular: { es: 'globo', en: 'balloon' }, plural: { es: 'globos', en: 'balloons' }, emoji: '🎈', gender: 'm' },
        { singular: { es: 'tarta', en: 'cake' }, plural: { es: 'tartas', en: 'cakes' }, emoji: '🎂', gender: 'f' },
        { singular: { es: 'corona', en: 'crown' }, plural: { es: 'coronas', en: 'crowns' }, emoji: '👑', gender: 'f' },
        { singular: { es: 'confeti', en: 'confetti' }, plural: { es: 'confetis', en: 'confetti' }, emoji: '🎊', gender: 'm' },
        { singular: { es: 'sorpresa', en: 'surprise' }, plural: { es: 'sorpresas', en: 'surprises' }, emoji: '🎉', gender: 'f' },
        { singular: { es: 'invitado', en: 'guest' }, plural: { es: 'invitados', en: 'guests' }, emoji: '👥', gender: 'm' },
        { singular: { es: 'caramelo', en: 'candy' }, plural: { es: 'caramelos', en: 'candies' }, emoji: '🍬', gender: 'm' },
        { singular: { es: 'serpentina', en: 'streamer' }, plural: { es: 'serpentinas', en: 'streamers' }, emoji: '🎀', gender: 'f' },
        { singular: { es: 'gorro de fiesta', en: 'party hat' }, plural: { es: 'gorros de fiesta', en: 'party hats' }, emoji: '🎩', gender: 'm' },
        { singular: { es: 'piñata', en: 'piñata' }, plural: { es: 'piñatas', en: 'piñatas' }, emoji: '🪅', gender: 'f' }
    ],
    'feria': [
        { singular: { es: 'ticket', en: 'ticket' }, plural: { es: 'tickets', en: 'tickets' }, emoji: '🎟️', gender: 'm' },
        { singular: { es: 'entrada', en: 'entrance' }, plural: { es: 'entradas', en: 'entrances' }, emoji: '🎫', gender: 'f' },
        { singular: { es: 'atracción', en: 'ride' }, plural: { es: 'atracciones', en: 'rides' }, emoji: '🎡', gender: 'f' },
        { singular: { es: 'premio', en: 'prize' }, plural: { es: 'premios', en: 'prizes' }, emoji: '🏆', gender: 'm' },
        { singular: { es: 'juego', en: 'game' }, plural: { es: 'juegos', en: 'games' }, emoji: '🎯', gender: 'm' },
        { singular: { es: 'algodón de azúcar', en: 'cotton candy' }, plural: { es: 'algodones de azúcar', en: 'cotton candies' }, emoji: '🍭', gender: 'm' },
        { singular: { es: 'vuelta', en: 'turn' }, plural: { es: 'vueltas', en: 'turns' }, emoji: '🎠', gender: 'f' },
        { singular: { es: 'churro', en: 'churro' }, plural: { es: 'churros', en: 'churros' }, emoji: '🥨', gender: 'm' },
        { singular: { es: 'helado', en: 'ice cream' }, plural: { es: 'helados', en: 'ice creams' }, emoji: '🍦', gender: 'm' },
        { singular: { es: 'caballito', en: 'little horse' }, plural: { es: 'caballitos', en: 'little horses' }, emoji: '🐴', gender: 'm' },
        { singular: { es: 'diana', en: 'dartboard' }, plural: { es: 'dianas', en: 'dartboards' }, emoji: '🎯', gender: 'f' },
        { singular: { es: 'globo de helio', en: 'helium balloon' }, plural: { es: 'globos de helio', en: 'helium balloons' }, emoji: '🎈', gender: 'm' }
    ],
    'cine': [
        { singular: { es: 'entrada', en: 'ticket' }, plural: { es: 'entradas', en: 'tickets' }, emoji: '🎬', gender: 'f' },
        { singular: { es: 'película', en: 'movie' }, plural: { es: 'películas', en: 'movies' }, emoji: '🎞️', gender: 'f' },
        { singular: { es: 'palomita', en: 'popcorn' }, plural: { es: 'palomitas', en: 'popcorn' }, emoji: '🍿', gender: 'f' },
        { singular: { es: 'asiento', en: 'seat' }, plural: { es: 'asientos', en: 'seats' }, emoji: '💺', gender: 'm' },
        { singular: { es: 'refresco', en: 'soda' }, plural: { es: 'refrescos', en: 'sodas' }, emoji: '🥤', gender: 'm' },
        { singular: { es: 'bolsa de chuches', en: 'candy bag' }, plural: { es: 'bolsas de chuches', en: 'candy bags' }, emoji: '🍬', gender: 'f' },
        { singular: { es: 'amigo', en: 'friend' }, plural: { es: 'amigos', en: 'friends' }, emoji: '👫', gender: 'm' },
        { singular: { es: 'nachos', en: 'nachos' }, plural: { es: 'nachos', en: 'nachos' }, emoji: '🌮', gender: 'm' },
        { singular: { es: 'gafa 3D', en: '3D glasses' }, plural: { es: 'gafas 3D', en: '3D glasses' }, emoji: '🕶️', gender: 'f' },
        { singular: { es: 'cartel', en: 'poster' }, plural: { es: 'carteles', en: 'posters' }, emoji: '🎦', gender: 'm' },
        { singular: { es: 'serie', en: 'series' }, plural: { es: 'series', en: 'series' }, emoji: '📺', gender: 'f' },
        { singular: { es: 'combo', en: 'combo' }, plural: { es: 'combos', en: 'combos' }, emoji: '🍿', gender: 'm' }
    ],
    'viaje_abuelos': [
        { singular: { es: 'foto', en: 'photo' }, plural: { es: 'fotos', en: 'photos' }, emoji: '📸', gender: 'f' },
        { singular: { es: 'recuerdo', en: 'souvenir' }, plural: { es: 'recuerdos', en: 'souvenirs' }, emoji: '🎁', gender: 'm' },
        { singular: { es: 'postal', en: 'postcard' }, plural: { es: 'postales', en: 'postcards' }, emoji: '💌', gender: 'f' },
        { singular: { es: 'maleta', en: 'suitcase' }, plural: { es: 'maletas', en: 'suitcases' }, emoji: '🧳', gender: 'f' },
        { singular: { es: 'souvenir', en: 'keepsake' }, plural: { es: 'souvenirs', en: 'keepsakes' }, emoji: '🗿', gender: 'm' },
        { singular: { es: 'mapa', en: 'map' }, plural: { es: 'mapas', en: 'maps' }, emoji: '🗺️', gender: 'm' },
        { singular: { es: 'aventura', en: 'adventure' }, plural: { es: 'aventuras', en: 'adventures' }, emoji: '🌍', gender: 'f' },
        { singular: { es: 'monumento', en: 'monument' }, plural: { es: 'monumentos', en: 'monuments' }, emoji: '🏛️', gender: 'm' },
        { singular: { es: 'historia', en: 'story' }, plural: { es: 'historias', en: 'stories' }, emoji: '📖', gender: 'f' },
        { singular: { es: 'pasaporte', en: 'passport' }, plural: { es: 'pasaportes', en: 'passports' }, emoji: '🛂', gender: 'm' },
        { singular: { es: 'billete', en: 'ticket' }, plural: { es: 'billetes', en: 'tickets' }, emoji: '🎫', gender: 'm' },
        { singular: { es: 'mochila', en: 'backpack' }, plural: { es: 'mochilas', en: 'backpacks' }, emoji: '🎒', gender: 'f' }
    ],
    'circo': [
        { singular: { es: 'payaso', en: 'clown' }, plural: { es: 'payasos', en: 'clowns' }, emoji: '🤡', gender: 'm' },
        { singular: { es: 'malabarista', en: 'juggler' }, plural: { es: 'malabaristas', en: 'jugglers' }, emoji: '🤹', gender: 'm' },
        { singular: { es: 'acróbata', en: 'acrobat' }, plural: { es: 'acróbatas', en: 'acrobats' }, emoji: '🤸', gender: 'm' },
        { singular: { es: 'pelota', en: 'ball' }, plural: { es: 'pelotas', en: 'balls' }, emoji: '⚽', gender: 'f' },
        { singular: { es: 'aro', en: 'hoop' }, plural: { es: 'aros', en: 'hoops' }, emoji: '⭕', gender: 'm' },
        { singular: { es: 'número', en: 'act' }, plural: { es: 'números', en: 'acts' }, emoji: '🎪', gender: 'm' },
        { singular: { es: 'trapecista', en: 'trapeze artist' }, plural: { es: 'trapecistas', en: 'trapeze artists' }, emoji: '🎭', gender: 'm' },
        { singular: { es: 'magia', en: 'magic trick' }, plural: { es: 'magias', en: 'magic tricks' }, emoji: '🪄', gender: 'f' },
        { singular: { es: 'sombrero de mago', en: 'magician hat' }, plural: { es: 'sombreros de mago', en: 'magician hats' }, emoji: '🎩', gender: 'm' },
        { singular: { es: 'capa', en: 'cape' }, plural: { es: 'capas', en: 'capes' }, emoji: '🦸', gender: 'f' },
        { singular: { es: 'equilibrista', en: 'tightrope walker' }, plural: { es: 'equilibristas', en: 'tightrope walkers' }, emoji: '🧜', gender: 'm' },
        { singular: { es: 'león', en: 'lion' }, plural: { es: 'leones', en: 'lions' }, emoji: '🦁', gender: 'm' }
    ],
    'restaurante': [
        { singular: { es: 'plato', en: 'dish' }, plural: { es: 'platos', en: 'dishes' }, emoji: '🍽️', gender: 'm' },
        { singular: { es: 'pizza', en: 'pizza' }, plural: { es: 'pizzas', en: 'pizzas' }, emoji: '🍕', gender: 'f' },
        { singular: { es: 'hamburguesa', en: 'burger' }, plural: { es: 'hamburguesas', en: 'burgers' }, emoji: '🍔', gender: 'f' },
        { singular: { es: 'refresco', en: 'drink' }, plural: { es: 'refrescos', en: 'drinks' }, emoji: '🥤', gender: 'm' },
        { singular: { es: 'postre', en: 'dessert' }, plural: { es: 'postres', en: 'desserts' }, emoji: '🍰', gender: 'm' },
        { singular: { es: 'ensalada', en: 'salad' }, plural: { es: 'ensaladas', en: 'salads' }, emoji: '🥗', gender: 'f' },
        { singular: { es: 'menú', en: 'menu' }, plural: { es: 'menús', en: 'menus' }, emoji: '📋', gender: 'm' },
        { singular: { es: 'pasta', en: 'pasta' }, plural: { es: 'pastas', en: 'pastas' }, emoji: '🍝', gender: 'f' },
        { singular: { es: 'helado', en: 'ice cream' }, plural: { es: 'helados', en: 'ice creams' }, emoji: '🍦', gender: 'm' },
        { singular: { es: 'servilleta', en: 'napkin' }, plural: { es: 'servilletas', en: 'napkins' }, emoji: '🧧', gender: 'f' },
        { singular: { es: 'tenedor', en: 'fork' }, plural: { es: 'tenedores', en: 'forks' }, emoji: '🍴', gender: 'm' },
        { singular: { es: 'cuchara', en: 'spoon' }, plural: { es: 'cucharas', en: 'spoons' }, emoji: '🥄', gender: 'f' }
    ],
    'disfraces': [
        { singular: { es: 'disfraz', en: 'costume' }, plural: { es: 'disfraces', en: 'costumes' }, emoji: '🎭', gender: 'm' },
        { singular: { es: 'máscara', en: 'mask' }, plural: { es: 'máscaras', en: 'masks' }, emoji: '🎭', gender: 'f' },
        { singular: { es: 'capa', en: 'cape' }, plural: { es: 'capas', en: 'capes' }, emoji: '🦸', gender: 'f' },
        { singular: { es: 'sombrero', en: 'hat' }, plural: { es: 'sombreros', en: 'hats' }, emoji: '🎩', gender: 'm' },
        { singular: { es: 'peluca', en: 'wig' }, plural: { es: 'pelucas', en: 'wigs' }, emoji: '💇', gender: 'f' },
        { singular: { es: 'accesorio', en: 'accessory' }, plural: { es: 'accesorios', en: 'accessories' }, emoji: '👑', gender: 'm' },
        { singular: { es: 'traje', en: 'suit' }, plural: { es: 'trajes', en: 'suits' }, emoji: '🤵', gender: 'm' },
        { singular: { es: 'espada', en: 'sword' }, plural: { es: 'espadas', en: 'swords' }, emoji: '⚔️', gender: 'f' },
        { singular: { es: 'varita mágica', en: 'magic wand' }, plural: { es: 'varitas mágicas', en: 'magic wands' }, emoji: '🪄', gender: 'f' },
        { singular: { es: 'alas', en: 'wings' }, plural: { es: 'alas', en: 'wings' }, emoji: '🧚', gender: 'f' },
        { singular: { es: 'escudo', en: 'shield' }, plural: { es: 'escudos', en: 'shields' }, emoji: '🛡️', gender: 'm' },
        { singular: { es: 'corona de princesa', en: 'princess crown' }, plural: { es: 'coronas de princesa', en: 'princess crowns' }, emoji: '👑', gender: 'f' }
    ],

    // 🛒 LUGARES DE COMPRAS
    'fruteria': [
        { singular: { es: 'manzana', en: 'apple' }, plural: { es: 'manzanas', en: 'apples' }, emoji: '🍎', gender: 'f' },
        { singular: { es: 'pera', en: 'pear' }, plural: { es: 'peras', en: 'pears' }, emoji: '🍐', gender: 'f' },
        { singular: { es: 'naranja', en: 'orange' }, plural: { es: 'naranjas', en: 'oranges' }, emoji: '🍊', gender: 'f' },
        { singular: { es: 'mandarina', en: 'mandarin' }, plural: { es: 'mandarinas', en: 'mandarins' }, emoji: '🍊', gender: 'f' },
        { singular: { es: 'ciruela', en: 'plum' }, plural: { es: 'ciruelas', en: 'plums' }, emoji: '🫐', gender: 'f' },
        { singular: { es: 'patata', en: 'potato' }, plural: { es: 'patatas', en: 'potatoes' }, emoji: '🥔', gender: 'f' },
        { singular: { es: 'tomate', en: 'tomato' }, plural: { es: 'tomates', en: 'tomatoes' }, emoji: '🍅', gender: 'm' },
        { singular: { es: 'plátano', en: 'banana' }, plural: { es: 'plátanos', en: 'bananas' }, emoji: '🍌', gender: 'm' },
        { singular: { es: 'kiwi', en: 'kiwi' }, plural: { es: 'kiwis', en: 'kiwis' }, emoji: '🥝', gender: 'm' },
        { singular: { es: 'fresa', en: 'strawberry' }, plural: { es: 'fresas', en: 'strawberries' }, emoji: '🍓', gender: 'f' },
        { singular: { es: 'uva', en: 'grape' }, plural: { es: 'uvas', en: 'grapes' }, emoji: '🍇', gender: 'f' },
        { singular: { es: 'cereza', en: 'cherry' }, plural: { es: 'cerezas', en: 'cherries' }, emoji: '🍒', gender: 'f' }
    ],
    'supermercado': [
        { singular: { es: 'lata', en: 'can' }, plural: { es: 'latas', en: 'cans' }, emoji: '🥫', gender: 'f' },
        { singular: { es: 'botella', en: 'bottle' }, plural: { es: 'botellas', en: 'bottles' }, emoji: '🍾', gender: 'f' },
        { singular: { es: 'caja', en: 'box' }, plural: { es: 'cajas', en: 'boxes' }, emoji: '📦', gender: 'f' },
        { singular: { es: 'paquete', en: 'package' }, plural: { es: 'paquetes', en: 'packages' }, emoji: '📦', gender: 'm' },
        { singular: { es: 'bote', en: 'jar' }, plural: { es: 'botes', en: 'jars' }, emoji: '🫙', gender: 'm' },
        { singular: { es: 'producto', en: 'product' }, plural: { es: 'productos', en: 'products' }, emoji: '🛒', gender: 'm' },
        { singular: { es: 'artículo', en: 'item' }, plural: { es: 'artículos', en: 'items' }, emoji: '📋', gender: 'm' },
        { singular: { es: 'bolsa', en: 'bag' }, plural: { es: 'bolsas', en: 'bags' }, emoji: '🛍️', gender: 'f' },
        { singular: { es: 'yogur', en: 'yogurt' }, plural: { es: 'yogures', en: 'yogurts' }, emoji: '🥛', gender: 'm' },
        { singular: { es: 'pan', en: 'bread' }, plural: { es: 'panes', en: 'breads' }, emoji: '🍞', gender: 'm' },
        { singular: { es: 'galleta', en: 'cookie' }, plural: { es: 'galletas', en: 'cookies' }, emoji: '🍪', gender: 'f' },
        { singular: { es: 'zumo', en: 'juice' }, plural: { es: 'zumos', en: 'juices' }, emoji: '🧃', gender: 'm' }
    ],
    'centro_comercial': [
        { singular: { es: 'bolsa', en: 'bag' }, plural: { es: 'bolsas', en: 'bags' }, emoji: '🛍️', gender: 'f' },
        { singular: { es: 'camiseta', en: 't-shirt' }, plural: { es: 'camisetas', en: 't-shirts' }, emoji: '👕', gender: 'f' },
        { singular: { es: 'gorra', en: 'cap' }, plural: { es: 'gorras', en: 'caps' }, emoji: '🧢', gender: 'f' },
        { singular: { es: 'zapatilla', en: 'sneaker' }, plural: { es: 'zapatillas', en: 'sneakers' }, emoji: '👟', gender: 'f' },
        { singular: { es: 'pantalón', en: 'pants' }, plural: { es: 'pantalones', en: 'pants' }, emoji: '👖', gender: 'm' },
        { singular: { es: 'libro', en: 'book' }, plural: { es: 'libros', en: 'books' }, emoji: '📚', gender: 'm' },
        { singular: { es: 'juguete', en: 'toy' }, plural: { es: 'juguetes', en: 'toys' }, emoji: '🧸', gender: 'm' },
        { singular: { es: 'peluche', en: 'plushie' }, plural: { es: 'peluches', en: 'plushies' }, emoji: '🧸', gender: 'm' },
        { singular: { es: 'calcetín', en: 'sock' }, plural: { es: 'calcetines', en: 'socks' }, emoji: '🧦', gender: 'm' },
        { singular: { es: 'bufanda', en: 'scarf' }, plural: { es: 'bufandas', en: 'scarfs' }, emoji: '🧣', gender: 'f' },
        { singular: { es: 'mochila', en: 'backpack' }, plural: { es: 'mochilas', en: 'backpacks' }, emoji: '🎒', gender: 'f' },
        { singular: { es: 'videojuego', en: 'videogame' }, plural: { es: 'videojuegos', en: 'videogames' }, emoji: '🎮', gender: 'm' }
    ],

    // 🌳 ENTORNOS NATURALES, FAUNA Y MASCOTAS
    'granja': [
        { singular: { es: 'gallina', en: 'chicken' }, plural: { es: 'gallinas', en: 'chickens' }, emoji: '🐔', gender: 'f' },
        { singular: { es: 'oveja', en: 'sheep' }, plural: { es: 'ovejas', en: 'sheep' }, emoji: '🐑', gender: 'f' },
        { singular: { es: 'vaca', en: 'cow' }, plural: { es: 'vacas', en: 'cows' }, emoji: '🐄', gender: 'f' },
        { singular: { es: 'cabra', en: 'goat' }, plural: { es: 'cabras', en: 'goats' }, emoji: '🐐', gender: 'f' },
        { singular: { es: 'pato', en: 'duck' }, plural: { es: 'patos', en: 'ducks' }, emoji: '🦆', gender: 'm' },
        { singular: { es: 'gallo', en: 'rooster' }, plural: { es: 'gallos', en: 'roosters' }, emoji: '🐓', gender: 'm' },
        { singular: { es: 'cerdo', en: 'pig' }, plural: { es: 'cerdos', en: 'pigs' }, emoji: '🐷', gender: 'm' },
        { singular: { es: 'conejo', en: 'rabbit' }, plural: { es: 'conejos', en: 'rabbits' }, emoji: '🐰', gender: 'm' },
        { singular: { es: 'caballo', en: 'horse' }, plural: { es: 'caballos', en: 'horses' }, emoji: '🐴', gender: 'm' },
        { singular: { es: 'oca', en: 'goose' }, plural: { es: 'ocas', en: 'geese' }, emoji: '🦢', gender: 'f' },
        { singular: { es: 'pollito', en: 'chick' }, plural: { es: 'pollitos', en: 'chicks' }, emoji: '🐥', gender: 'm' },
        { singular: { es: 'burro', en: 'donkey' }, plural: { es: 'burros', en: 'donkeys' }, emoji: '🫏', gender: 'm' }
    ],
    'huerto': [
        { singular: { es: 'zanahoria', en: 'carrot' }, plural: { es: 'zanahorias', en: 'carrots' }, emoji: '🥕', gender: 'f' },
        { singular: { es: 'lechuga', en: 'lettuce' }, plural: { es: 'lechugas', en: 'lettuces' }, emoji: '🥬', gender: 'f' },
        { singular: { es: 'calabaza', en: 'pumpkin' }, plural: { es: 'calabazas', en: 'pumpkins' }, emoji: '🎃', gender: 'f' },
        { singular: { es: 'berenjena', en: 'eggplant' }, plural: { es: 'berenjenas', en: 'eggplants' }, emoji: '🍆', gender: 'f' },
        { singular: { es: 'pepino', en: 'cucumber' }, plural: { es: 'pepinos', en: 'cucumbers' }, emoji: '🥒', gender: 'm' },
        { singular: { es: 'pimiento', en: 'pepper' }, plural: { es: 'pimientos', en: 'peppers' }, emoji: '🫑', gender: 'm' },
        { singular: { es: 'rábano', en: 'radish' }, plural: { es: 'rábanos', en: 'radishes' }, emoji: '🌶️', gender: 'm' },
        { singular: { es: 'calabacín', en: 'zucchini' }, plural: { es: 'calabacines', en: 'zucchinis' }, emoji: '🥒', gender: 'm' }
    ],
    'parque': [
        { singular: { es: 'flor', en: 'flower' }, plural: { es: 'flores', en: 'flowers' }, emoji: '🌺', gender: 'f' },
        { singular: { es: 'hoja', en: 'leaf' }, plural: { es: 'hojas', en: 'leaves' }, emoji: '🍃', gender: 'f' },
        { singular: { es: 'piedra', en: 'stone' }, plural: { es: 'piedras', en: 'stones' }, emoji: '🪨', gender: 'f' },
        { singular: { es: 'rama', en: 'branch' }, plural: { es: 'ramas', en: 'branches' }, emoji: '🌿', gender: 'f' },
        { singular: { es: 'árbol', en: 'tree' }, plural: { es: 'árboles', en: 'trees' }, emoji: '🌳', gender: 'm' },
        { singular: { es: 'columpio', en: 'swing' }, plural: { es: 'columpios', en: 'swings' }, emoji: '🌲', gender: 'm' },
        { singular: { es: 'tobogán', en: 'slide' }, plural: { es: 'toboganes', en: 'slides' }, emoji: '🛝', gender: 'm' },
        { singular: { es: 'banco', en: 'bench' }, plural: { es: 'bancos', en: 'benches' }, emoji: '🪑', gender: 'm' }
    ],
    'playa': [
        { singular: { es: 'concha', en: 'shell' }, plural: { es: 'conchas', en: 'shells' }, emoji: '🐚', gender: 'f' },
        { singular: { es: 'estrella de mar', en: 'starfish' }, plural: { es: 'estrellas de mar', en: 'starfish' }, emoji: '⭐', gender: 'f' },
        { singular: { es: 'piedra', en: 'stone' }, plural: { es: 'piedras', en: 'stones' }, emoji: '🪨', gender: 'f' },
        { singular: { es: 'alga', en: 'seaweed' }, plural: { es: 'algas', en: 'seaweed' }, emoji: '🌿', gender: 'f' },
        { singular: { es: 'cangrejo', en: 'crab' }, plural: { es: 'cangrejos', en: 'crabs' }, emoji: '🦀', gender: 'm' },
        { singular: { es: 'pez', en: 'fish' }, plural: { es: 'peces', en: 'fish' }, emoji: '🐠', gender: 'm' },
        { singular: { es: 'cubo', en: 'bucket' }, plural: { es: 'cubos', en: 'buckets' }, emoji: '🪣', gender: 'm' },
        { singular: { es: 'castillo de arena', en: 'sandcastle' }, plural: { es: 'castillos de arena', en: 'sandcastles' }, emoji: '🏖️', gender: 'm' }
    ],
    'centro_animales': [
        { singular: { es: 'perro', en: 'dog' }, plural: { es: 'perros', en: 'dogs' }, emoji: '🐕', gender: 'm' },
        { singular: { es: 'gato', en: 'cat' }, plural: { es: 'gatos', en: 'cats' }, emoji: '🐈', gender: 'm' },
        { singular: { es: 'loro', en: 'parrot' }, plural: { es: 'loros', en: 'parrots' }, emoji: '🦜', gender: 'm' },
        { singular: { es: 'tortuga', en: 'turtle' }, plural: { es: 'tortugas', en: 'turtles' }, emoji: '🐢', gender: 'f' },
        { singular: { es: 'hamster', en: 'hamster' }, plural: { es: 'hamsters', en: 'hamsters' }, emoji: '🐹', gender: 'm' },
        { singular: { es: 'cobaya', en: 'guinea pig' }, plural: { es: 'cobayas', en: 'guinea pigs' }, emoji: '🐹', gender: 'f' },
        { singular: { es: 'conejo', en: 'rabbit' }, plural: { es: 'conejos', en: 'rabbits' }, emoji: '🐰', gender: 'm' }
    ],
    'concurso_canino': [
        { singular: { es: 'perro', en: 'dog' }, plural: { es: 'perros', en: 'dogs' }, emoji: '🐕', gender: 'm' },
        { singular: { es: 'cachorro', en: 'puppy' }, plural: { es: 'cachorros', en: 'puppies' }, emoji: '🐶', gender: 'm' },
        { singular: { es: 'medalla', en: 'medal' }, plural: { es: 'medallas', en: 'medals' }, emoji: '🏅', gender: 'f' },
        { singular: { es: 'premio', en: 'prize' }, plural: { es: 'premios', en: 'prizes' }, emoji: '🏆', gender: 'm' },
        { singular: { es: 'trofeo', en: 'trophy' }, plural: { es: 'trofeos', en: 'trophies' }, emoji: '🏆', gender: 'm' },
        { singular: { es: 'participante', en: 'participant' }, plural: { es: 'participantes', en: 'participants' }, emoji: '🐕‍🦺', gender: 'm' },
        { singular: { es: 'competidor', en: 'competitor' }, plural: { es: 'competidores', en: 'competitors' }, emoji: '🐕', gender: 'm' }
    ],
    'exposicion_plantas': [
        { singular: { es: 'flor', en: 'flower' }, plural: { es: 'flores', en: 'flowers' }, emoji: '🌺', gender: 'f' },
        { singular: { es: 'rosa', en: 'rose' }, plural: { es: 'rosas', en: 'roses' }, emoji: '🌹', gender: 'f' },
        { singular: { es: 'margarita', en: 'daisy' }, plural: { es: 'margaritas', en: 'daisies' }, emoji: '🌼', gender: 'f' },
        { singular: { es: 'planta', en: 'plant' }, plural: { es: 'plantas', en: 'plants' }, emoji: '🌱', gender: 'f' },
        { singular: { es: 'tulipán', en: 'tulip' }, plural: { es: 'tulipanes', en: 'tulips' }, emoji: '🌷', gender: 'm' },
        { singular: { es: 'girasol', en: 'sunflower' }, plural: { es: 'girasoles', en: 'sunflowers' }, emoji: '🌻', gender: 'm' },
        { singular: { es: 'cactus', en: 'cactus' }, plural: { es: 'cactus', en: 'cacti' }, emoji: '🌵', gender: 'm' },
        { singular: { es: 'macetero', en: 'pot' }, plural: { es: 'maceteros', en: 'pots' }, emoji: '🪴', gender: 'm' }
    ],
    'acuario': [
        { singular: { es: 'pez', en: 'fish' }, plural: { es: 'peces', en: 'fish' }, emoji: '🐠', gender: 'm' },
        { singular: { es: 'medusa', en: 'jellyfish' }, plural: { es: 'medusas', en: 'jellyfish' }, emoji: '🪼', gender: 'f' },
        { singular: { es: 'estrella de mar', en: 'starfish' }, plural: { es: 'estrellas de mar', en: 'starfish' }, emoji: '⭐', gender: 'f' },
        { singular: { es: 'tortuga', en: 'turtle' }, plural: { es: 'tortugas', en: 'turtles' }, emoji: '🐢', gender: 'f' },
        { singular: { es: 'pulpo', en: 'octopus' }, plural: { es: 'pulpos', en: 'octopuses' }, emoji: '🐙', gender: 'm' },
        { singular: { es: 'caballito de mar', en: 'seahorse' }, plural: { es: 'caballitos de mar', en: 'seahorses' }, emoji: '🦭', gender: 'm' },
        { singular: { es: 'tiburón', en: 'shark' }, plural: { es: 'tiburones', en: 'sharks' }, emoji: '🦈', gender: 'm' }
    ],
    'excursion_monte': [
        { singular: { es: 'piedra', en: 'stone' }, plural: { es: 'piedras', en: 'stones' }, emoji: '🪨', gender: 'f' },
        { singular: { es: 'hoja', en: 'leaf' }, plural: { es: 'hojas', en: 'leaves' }, emoji: '🍃', gender: 'f' },
        { singular: { es: 'rama', en: 'branch' }, plural: { es: 'ramas', en: 'branches' }, emoji: '🌿', gender: 'f' },
        { singular: { es: 'piña', en: 'pinecone' }, plural: { es: 'piñas', en: 'pinecones' }, emoji: '🌰', gender: 'f' },
        { singular: { es: 'palo', en: 'stick' }, plural: { es: 'palos', en: 'sticks' }, emoji: '🪵', gender: 'm' },
        { singular: { es: 'árbol', en: 'tree' }, plural: { es: 'árboles', en: 'trees' }, emoji: '🌳', gender: 'm' },
        { singular: { es: 'arbusto', en: 'bush' }, plural: { es: 'arbustos', en: 'bushes' }, emoji: '🌳', gender: 'm' }
    ],
    'mascotas': [
        { singular: { es: 'mascota', en: 'pet' }, plural: { es: 'mascotas', en: 'pets' }, emoji: '🐾', gender: 'f' },
        { singular: { es: 'correa', en: 'leash' }, plural: { es: 'correas', en: 'leashes' }, emoji: '🦮', gender: 'f' },
        { singular: { es: 'pelota', en: 'ball' }, plural: { es: 'pelotas', en: 'balls' }, emoji: '⚽', gender: 'f' },
        { singular: { es: 'juguete', en: 'toy' }, plural: { es: 'juguetes', en: 'toys' }, emoji: '🧸', gender: 'm' },
        { singular: { es: 'collar', en: 'collar' }, plural: { es: 'collares', en: 'collars' }, emoji: '⭕', gender: 'm' },
        { singular: { es: 'cuenco', en: 'bowl' }, plural: { es: 'cuencos', en: 'bowls' }, emoji: '🥣', gender: 'm' },
        { singular: { es: 'hueso', en: 'bone' }, plural: { es: 'huesos', en: 'bones' }, emoji: '🦴', gender: 'm' }
    ],

    // 🏠 ACCIONES COTIDIANAS
    'cocina': [
        { singular: { es: 'galleta', en: 'cookie' }, plural: { es: 'galletas', en: 'cookies' }, emoji: '🍪', gender: 'f' },
        { singular: { es: 'magdalena', en: 'muffin' }, plural: { es: 'magdalenas', en: 'muffins' }, emoji: '🧁', gender: 'f' },
        { singular: { es: 'tarta', en: 'cake' }, plural: { es: 'tartas', en: 'cakes' }, emoji: '🎂', gender: 'f' },
        { singular: { es: 'cucharada', en: 'spoonful' }, plural: { es: 'cucharadas', en: 'spoonfuls' }, emoji: '🥄', gender: 'f' },
        { singular: { es: 'ingrediente', en: 'ingredient' }, plural: { es: 'ingredientes', en: 'ingredients' }, emoji: '🧂', gender: 'm' },
        { singular: { es: 'pastel', en: 'pastry' }, plural: { es: 'pasteles', en: 'pastries' }, emoji: '🥧', gender: 'm' },
        { singular: { es: 'dulce', en: 'sweet' }, plural: { es: 'dulces', en: 'sweets' }, emoji: '🍬', gender: 'm' }
    ],
    'juguetes': [
        { singular: { es: 'juguete', en: 'toy' }, plural: { es: 'juguetes', en: 'toys' }, emoji: '🧸', gender: 'm' },
        { singular: { es: 'muñeca', en: 'doll' }, plural: { es: 'muñecas', en: 'dolls' }, emoji: '🪆', gender: 'f' },
        { singular: { es: 'pelota', en: 'ball' }, plural: { es: 'pelotas', en: 'balls' }, emoji: '⚽', gender: 'f' },
        { singular: { es: 'pieza de lego', en: 'lego piece' }, plural: { es: 'piezas de lego', en: 'lego pieces' }, emoji: '🧩', gender: 'f' },
        { singular: { es: 'coche de juguete', en: 'toy car' }, plural: { es: 'coches de juguete', en: 'toy cars' }, emoji: '🚗', gender: 'm' },
        { singular: { es: 'peluche', en: 'stuffed animal' }, plural: { es: 'peluches', en: 'stuffed animals' }, emoji: '🧸', gender: 'm' },
        { singular: { es: 'puzzle', en: 'puzzle' }, plural: { es: 'puzzles', en: 'puzzles' }, emoji: '🧩', gender: 'm' }
    ],
    'deporte': [
        { singular: { es: 'balón', en: 'ball' }, plural: { es: 'balones', en: 'balls' }, emoji: '⚽', gender: 'm' },
        { singular: { es: 'raqueta', en: 'racket' }, plural: { es: 'raquetas', en: 'rackets' }, emoji: '🎾', gender: 'f' },
        { singular: { es: 'pelota', en: 'ball' }, plural: { es: 'pelotas', en: 'balls' }, emoji: '🏀', gender: 'f' },
        { singular: { es: 'red', en: 'net' }, plural: { es: 'redes', en: 'nets' }, emoji: '🥅', gender: 'f' },
        { singular: { es: 'gol', en: 'goal' }, plural: { es: 'goles', en: 'goals' }, emoji: '⚽', gender: 'm' },
        { singular: { es: 'punto', en: 'point' }, plural: { es: 'puntos', en: 'points' }, emoji: '🎯', gender: 'm' },
        { singular: { es: 'tanto', en: 'score' }, plural: { es: 'tantos', en: 'scores' }, emoji: '🏆', gender: 'm' }
    ],
    'ordenando_cuarto': [
        { singular: { es: 'libro', en: 'book' }, plural: { es: 'libros', en: 'books' }, emoji: '📚', gender: 'm' },
        { singular: { es: 'camiseta', en: 't-shirt' }, plural: { es: 'camisetas', en: 't-shirts' }, emoji: '👕', gender: 'f' },
        { singular: { es: 'zapatilla', en: 'shoe' }, plural: { es: 'zapatillas', en: 'shoes' }, emoji: '👟', gender: 'f' },
        { singular: { es: 'prenda', en: 'garment' }, plural: { es: 'prendas', en: 'garments' }, emoji: '👔', gender: 'f' },
        { singular: { es: 'cuaderno', en: 'notebook' }, plural: { es: 'cuadernos', en: 'notebooks' }, emoji: '📓', gender: 'm' },
        { singular: { es: 'lápiz', en: 'pencil' }, plural: { es: 'lápices', en: 'pencils' }, emoji: '✏️', gender: 'm' },
        { singular: { es: 'objeto', en: 'object' }, plural: { es: 'objetos', en: 'objects' }, emoji: '📦', gender: 'm' }
    ],
    'manualidades': [
        { singular: { es: 'papel', en: 'paper' }, plural: { es: 'papeles', en: 'papers' }, emoji: '📄', gender: 'm' },
        { singular: { es: 'tijera', en: 'scissors' }, plural: { es: 'tijeras', en: 'scissors' }, emoji: '✂️', gender: 'f' },
        { singular: { es: 'pegatina', en: 'sticker' }, plural: { es: 'pegatinas', en: 'stickers' }, emoji: '🌟', gender: 'f' },
        { singular: { es: 'figura', en: 'figure' }, plural: { es: 'figuras', en: 'figures' }, emoji: '🎨', gender: 'f' },
        { singular: { es: 'lápiz de color', en: 'colored pencil' }, plural: { es: 'lápices de color', en: 'colored pencils' }, emoji: '🖍️', gender: 'm' },
        { singular: { es: 'rotulador', en: 'marker' }, plural: { es: 'rotuladores', en: 'markers' }, emoji: '🖊️', gender: 'm' },
        { singular: { es: 'dibujo', en: 'drawing' }, plural: { es: 'dibujos', en: 'drawings' }, emoji: '🎨', gender: 'm' }
    ],
    'cromos': [
        { singular: { es: 'cromo', en: 'sticker' }, plural: { es: 'cromos', en: 'stickers' }, emoji: '🃏', gender: 'm' },
        { singular: { es: 'carta', en: 'card' }, plural: { es: 'cartas', en: 'cards' }, emoji: '🎴', gender: 'f' },
        { singular: { es: 'pegatina', en: 'sticker' }, plural: { es: 'pegatinas', en: 'stickers' }, emoji: '✨', gender: 'f' },
        { singular: { es: 'figurita', en: 'trading card' }, plural: { es: 'figuritas', en: 'trading cards' }, emoji: '🎴', gender: 'f' },
        { singular: { es: 'sobre', en: 'pack' }, plural: { es: 'sobres', en: 'packs' }, emoji: '✉️', gender: 'm' },
        { singular: { es: 'duplicado', en: 'duplicate' }, plural: { es: 'duplicados', en: 'duplicates' }, emoji: '🔄', gender: 'm' },
        { singular: { es: 'álbum', en: 'album' }, plural: { es: 'álbumes', en: 'albums' }, emoji: '📔', gender: 'm' }
    ],

    // 📚 LUGARES DE INTERÉS
    'biblioteca': [
        { singular: { es: 'libro', en: 'book' }, plural: { es: 'libros', en: 'books' }, emoji: '📖', gender: 'm' },
        { singular: { es: 'novela', en: 'novel' }, plural: { es: 'novelas', en: 'novels' }, emoji: '📚', gender: 'f' },
        { singular: { es: 'revista', en: 'magazine' }, plural: { es: 'revistas', en: 'magazines' }, emoji: '📰', gender: 'f' },
        { singular: { es: 'cómic', en: 'comic' }, plural: { es: 'cómics', en: 'comics' }, emoji: '📕', gender: 'm' },
        { singular: { es: 'cuento', en: 'storybook' }, plural: { es: 'cuentos', en: 'storybooks' }, emoji: '📘', gender: 'm' },
        { singular: { es: 'atlas', en: 'atlas' }, plural: { es: 'atlas', en: 'atlases' }, emoji: '🗺️', gender: 'm' },
        { singular: { es: 'diccionario', en: 'dictionary' }, plural: { es: 'diccionarios', en: 'dictionaries' }, emoji: '📙', gender: 'm' }
    ],
    'patio_colegio': [
        { singular: { es: 'amigo', en: 'friend' }, plural: { es: 'amigos', en: 'friends' }, emoji: '👦', gender: 'm' },
        { singular: { es: 'compañera', en: 'classmate' }, plural: { es: 'compañeras', en: 'classmates' }, emoji: '👧', gender: 'f' },
        { singular: { es: 'pelota', en: 'ball' }, plural: { es: 'pelotas', en: 'balls' }, emoji: '⚽', gender: 'f' },
        { singular: { es: 'comba', en: 'jump rope' }, plural: { es: 'combas', en: 'jump ropes' }, emoji: '🪢', gender: 'f' },
        { singular: { es: 'juego', en: 'game' }, plural: { es: 'juegos', en: 'games' }, emoji: '🎮', gender: 'm' },
        { singular: { es: 'balón', en: 'ball' }, plural: { es: 'balones', en: 'balls' }, emoji: '🏀', gender: 'm' },
        { singular: { es: 'niño', en: 'child' }, plural: { es: 'niños', en: 'children' }, emoji: '👶', gender: 'm' }
    ],
    'museo': [
        { singular: { es: 'fósil', en: 'fossil' }, plural: { es: 'fósiles', en: 'fossils' }, emoji: '🦴', gender: 'm' },
        { singular: { es: 'estatua', en: 'statue' }, plural: { es: 'estatuas', en: 'statues' }, emoji: '🗿', gender: 'f' },
        { singular: { es: 'pintura', en: 'painting' }, plural: { es: 'pinturas', en: 'paintings' }, emoji: '🖼️', gender: 'f' },
        { singular: { es: 'escultura', en: 'sculpture' }, plural: { es: 'esculturas', en: 'sculptures' }, emoji: '🗿', gender: 'f' },
        { singular: { es: 'cuadro', en: 'picture' }, plural: { es: 'cuadros', en: 'pictures' }, emoji: '🖼️', gender: 'm' },
        { singular: { es: 'objeto antiguo', en: 'antique' }, plural: { es: 'objetos antiguos', en: 'antiques' }, emoji: '🏺', gender: 'm' },
        { singular: { es: 'artefacto', en: 'artifact' }, plural: { es: 'artefactos', en: 'artifacts' }, emoji: '⚱️', gender: 'm' }
    ],
    'bomberos': [
        { singular: { es: 'manguera', en: 'hose' }, plural: { es: 'mangueras', en: 'hoses' }, emoji: '🚒', gender: 'f' },
        { singular: { es: 'escalera', en: 'ladder' }, plural: { es: 'escaleras', en: 'ladders' }, emoji: '🪜', gender: 'f' },
        { singular: { es: 'sirena', en: 'siren' }, plural: { es: 'sirenas', en: 'sirens' }, emoji: '🚨', gender: 'f' },
        { singular: { es: 'casco', en: 'helmet' }, plural: { es: 'cascos', en: 'helmets' }, emoji: '⛑️', gender: 'm' },
        { singular: { es: 'extintor', en: 'extinguisher' }, plural: { es: 'extintores', en: 'extinguishers' }, emoji: '🧯', gender: 'm' },
        { singular: { es: 'bombero', en: 'firefighter' }, plural: { es: 'bomberos', en: 'firefighters' }, emoji: '👨‍🚒', gender: 'm' },
        { singular: { es: 'camión', en: 'truck' }, plural: { es: 'camiones', en: 'trucks' }, emoji: '🚒', gender: 'm' }
    ],
    'hospital': [
        { singular: { es: 'venda', en: 'bandage' }, plural: { es: 'vendas', en: 'bandages' }, emoji: '🩹', gender: 'f' },
        { singular: { es: 'tirita', en: 'band-aid' }, plural: { es: 'tiritas', en: 'band-aids' }, emoji: '🩹', gender: 'f' },
        { singular: { es: 'medicina', en: 'medicine' }, plural: { es: 'medicinas', en: 'medicines' }, emoji: '💊', gender: 'f' },
        { singular: { es: 'jeringuilla', en: 'syringe' }, plural: { es: 'jeringuillas', en: 'syringes' }, emoji: '💉', gender: 'f' },
        { singular: { es: 'termómetro', en: 'thermometer' }, plural: { es: 'termómetros', en: 'thermometers' }, emoji: '🌡️', gender: 'm' },
        { singular: { es: 'estetoscopio', en: 'stethoscope' }, plural: { es: 'estetoscopios', en: 'stethoscopes' }, emoji: '🩺', gender: 'm' },
        { singular: { es: 'paciente', en: 'patient' }, plural: { es: 'pacientes', en: 'patients' }, emoji: '🤒', gender: 'm' }
    ],
    'castillo': [
        { singular: { es: 'torre', en: 'tower' }, plural: { es: 'torres', en: 'towers' }, emoji: '🏰', gender: 'f' },
        { singular: { es: 'bandera', en: 'flag' }, plural: { es: 'banderas', en: 'flags' }, emoji: '🚩', gender: 'f' },
        { singular: { es: 'armadura', en: 'armor' }, plural: { es: 'armaduras', en: 'armors' }, emoji: '🛡️', gender: 'f' },
        { singular: { es: 'espada', en: 'sword' }, plural: { es: 'espadas', en: 'swords' }, emoji: '⚔️', gender: 'f' },
        { singular: { es: 'escudo', en: 'shield' }, plural: { es: 'escudos', en: 'shields' }, emoji: '🛡️', gender: 'm' },
        { singular: { es: 'caballero', en: 'knight' }, plural: { es: 'caballeros', en: 'knights' }, emoji: '🤺', gender: 'm' },
        { singular: { es: 'soldado', en: 'soldier' }, plural: { es: 'soldados', en: 'soldiers' }, emoji: '💂', gender: 'm' }
    ]
};

// ========================================
// CONTEXT CONTAINERS MAPPING
// Contenedores/agrupadores específicos por contexto
// Reemplaza palabras genéricas como "grupo" con vocabulario contextual
// ========================================

const CONTEXT_CONTAINERS = {
    // MOMENTOS ESPECIALES
    'cumpleanos': { es: 'mesa', en: 'table' },
    'feria': { es: 'puesto', en: 'stand' },
    'cine': { es: 'sala', en: 'room' },
    'viaje_abuelos': { es: 'maleta', en: 'suitcase' },
    'circo': { es: 'pista', en: 'ring' },
    'restaurante': { es: 'plato', en: 'plate' },
    'disfraces': { es: 'baúl', en: 'trunk' },

    // LUGARES DE COMPRAS  
    'fruteria': { es: 'cesta', en: 'basket' },
    'supermercado': { es: 'carrito', en: 'cart' },
    'centro_comercial': { es: 'bolsa', en: 'bag' },

    // ENTORNOS NATURALES, FAUNA Y MASCOTAS
    'granja': { es: 'corral', en: 'pen' },
    'huerto': { es: 'caja', en: 'box' },
    'parque': { es: 'zona', en: 'area' },
    'playa': { es: 'cubo', en: 'bucket' },
    'centro_animales': { es: 'jaula', en: 'cage' },
    'concurso_canino': { es: 'categoría', en: 'category' },
    'exposicion_plantas': { es: 'maceta', en: 'pot' },
    'acuario': { es: 'tanque', en: 'tank' },
    'excursion_monte': { es: 'mochila', en: 'backpack' },
    'mascotas': { es: 'jaula', en: 'cage' },

    // ACCIONES COTIDIANAS
    'cocina': { es: 'plato', en: 'plate' },
    'juguetes': { es: 'caja', en: 'box' },
    'deporte': { es: 'red', en: 'net' },
    'ordenando_cuarto': { es: 'estante', en: 'shelf' },
    'manualidades': { es: 'bandeja', en: 'tray' },
    'cromos': { es: 'álbum', en: 'album' },

    // LUGARES DE INTERÉS
    'biblioteca': { es: 'estante', en: 'shelf' },
    'patio_colegio': { es: 'equipo', en: 'team' },
    'museo': { es: 'vitrina', en: 'display case' },
    'bomberos': { es: 'camión', en: 'truck' },
    'hospital': { es: 'caja', en: 'box' },
    'castillo': { es: 'sala', en: 'room' }
};

// ========================================
// OBJECT VARIETY SYSTEM - Tracking and Selection
// Garantiza máximo 9% de repetición del mismo objeto
// ========================================

// Tracking simple por contexto (se mantiene durante toda la sesión)
const objectUsageCount = {
    // Formato: 'contextId': { 'manzanas': count, 'peras': count, ... }
};

/**
 * Selecciona un objeto aleatorio del contexto con control de repeticiones (máx 9%)
 * @param {string} contextId - ID del contexto (ej: 'fruteria', 'granja')
 * @returns {Object} Objeto seleccionado con {singular, plural, emoji, gender}
 */
function getBalancedContextObject(contextId) {
    const objects = CONTEXT_OBJECTS[contextId];

    // Si no es array (contexto antiguo sin variedad), devolver tal cual
    if (!Array.isArray(objects)) {
        return objects || {
            singular: { es: 'objeto', en: 'object' },
            plural: { es: 'objetos', en: 'objects' },
            emoji: '📦',
            gender: 'm'
        };
    }

    // Inicializar tracking para este contexto si no existe
    if (!objectUsageCount[contextId]) {
        objectUsageCount[contextId] = {};
    }

    const usage = objectUsageCount[contextId];

    // Calcular total de usos en este contexto
    const totalUses = Object.values(usage).reduce((sum, count) => sum + count, 0);

    // Calcular límite del 9%
    const maxUsage = Math.ceil(totalUses * 0.09);

    // Filtrar objetos que NO han excedido el 9%
    let availableObjects = objects;
    if (totalUses > 10) { // Solo aplicar límite después de 10+ problemas (fase de calentamiento)
        availableObjects = objects.filter(obj => {
            const objKey = obj.plural.es;
            const currentUsage = usage[objKey] || 0;
            return currentUsage < maxUsage;
        });
    }

    // Si todos excedieron (edge case muy improbable), resetear y usar todos
    if (availableObjects.length === 0) {
        console.warn(`⚠️ [Variety System] Todos los objetos de '${contextId}' excedieron el 9%. Reseteando...`);
        availableObjects = objects;
        objectUsageCount[contextId] = {}; // Reset tracking
    }

    // Seleccionar aleatoriamente de los disponibles
    const selected = availableObjects[Math.floor(Math.random() * availableObjects.length)];

    // Actualizar contador
    const selectedKey = selected.plural.es;
    usage[selectedKey] = (usage[selectedKey] || 0) + 1;

    // Log para debugging (solo en desarrollo)
    if (totalUses > 0 && totalUses % 10 === 0) {
        console.log(`📊 [Variety] Contexto '${contextId}' - ${totalUses} problemas:`, usage);
    }

    return selected;
}

/**
 * Resetea el tracking de uso de objetos (útil para batch generation)
 * @param {string} contextId - ID del contexto específico, o undefined para resetear todos
 */
function resetObjectUsageTracking(contextId) {
    if (contextId) {
        objectUsageCount[contextId] = {};
        console.log(`🔄 [Variety] Reset tracking para contexto: ${contextId}`);
    } else {
        Object.keys(objectUsageCount).forEach(key => {
            objectUsageCount[key] = {};
        });
        console.log('🔄 [Variety] Reset tracking para TODOS los contextos');
    }
}

// ========================================
// MOCK GENERATOR (FALLBACK)



/**
 * Genera 5 problemas matemáticos basados en la configuración del usuario
 * @param {Object} config - Configuración de la sesión (tipo, nivel, contexto)
 * @returns {Array} Array de 5 problemas
 */
function generateProblems(config) {
    console.log('🎲 Generando problemas con configuración:', config);

    // INTERCEPTAR PARA CONTINUIDAD NARRATIVA (STORY MODE) - SÓLO PARA NUEVA MISIÓN (ANY)
    if (config.context === 'cumpleanos' && config.problemType === 'any') {
        const story = getCumpleanosStorySequence(config);
        if (story) return story;
    }

    const problems = [];
    const context = CONTEXTS.find(ctx => ctx.id === config.context);

    // Rangos de números según nivel (Defaults)
    const numberRanges = {
        'beginner': { min: 1, max: 10 },
        'advanced': { min: 10, max: 25 },
        'expert': { min: 20, max: 49 }
    };

    let range = numberRanges[config.level] || numberRanges['beginner'];

    // OVERRIDE: Dynamic Difficulty from Phase 3 Recommendation Engine
    if (window.SessionConfig && window.SessionConfig.numberRange) {
        console.log('🎯 Applying dynamic difficulty range:', window.SessionConfig.numberRange);
        range = { min: 1, max: window.SessionConfig.numberRange };
    }

    // Generar 5 problemas
    for (let i = 0; i < 5; i++) {
        const problem = generateSingleProblem(i + 1, config, range, context);
        problems.push(problem);
    }

    console.log('✅ 5 problemas generados:', problems);
    return problems;
}

/**
 * Genera un problema individual
 */
function generateSingleProblem(number, config, range, context) {
    // Si es 'any', elegir tipo aleatorio
    const problemTypes = ['sum', 'subtraction'];
    const actualType = config.problemType === 'any'
        ? problemTypes[Math.floor(Math.random() * problemTypes.length)]
        : config.problemType;

    let problem = {
        id: number,
        type: actualType,
        contextId: context.id,
        contextName: context.title,
        contextColor: context.color
    };

    // Generar problema según tipo
    switch (actualType) {
        case 'sum':
            problem = { ...problem, ...generateSumProblem(range, context, config.level) };
            break;
        case 'subtraction':
            problem = { ...problem, ...generateSubtractionProblem(range, context, config.level) };
            break;
    }

    // Generate unique ID based on content (after we have the data)
    if (problem.data && problem.data.useful) {
        problem.id = `${context.id}_${actualType}_${problem.data.useful[0]}_${problem.data.useful[1]}`;
    }

    return problem; // Ensure problem is returned after switch

}


/**
 * Genera un problema de suma
 */
function generateSumProblem(range, context, level) {
    const num1 = randomInRange(range.min, range.max);
    const num2 = randomInRange(range.min, range.max);
    const sum = num1 + num2;

    // Dato distractor solo si NO es nivel beginner
    const useDistractor = level !== 'beginner';
    const distractor = useDistractor ? randomInRange(range.min, range.max) : null;

    // Obtener objeto del contexto balanceado
    const selectedObj = getBalancedContextObject(context.id);

    // Usar narrativas contextuales (siempre disponible desde contextualNarratives.js)
    if (typeof generateContextualNarrative !== 'undefined') {
        const mathData = { num1, num2, distractor, answer: sum };
        const lang = typeof currentLanguage !== 'undefined' ? currentLanguage : 'es-ES';
        const narrative = generateContextualNarrative(mathData, 'suma', context.id, level, selectedObj, lang);

        return {
            statement: {
                'es-ES': narrative.story_text,
                'en-GB': narrative.story_text  // Por ahora solo ES
            },
            question: narrative.question,
            data: {
                useful: [num1, num2],
                distracting: useDistractor ? [distractor] : []
            },
            solution: {
                answer: sum,
                operation: `${num1} + ${num2} = ${sum}`,
                operationType: 'sum'
            }
        };
    }

    // Fallback ultra-básico (solo si contextualNarratives.js no está cargado)
    const contextObj = getBalancedContextObject(context.id);
    const lang = (typeof currentLanguage !== 'undefined' ? currentLanguage : 'es-ES') === 'es-ES' ? 'es' : 'en';
    const objPlural = contextObj.plural[lang];

    return {
        statement: {
            'es-ES': `Hay ${num1} ${objPlural} y se añaden ${num2} ${objPlural} más.`,
            'en-GB': `There are ${num1} ${objPlural} and ${num2} more ${objPlural} are added.`
        },
        question: `¿Cuántos ${objPlural} hay en total?`,
        data: {
            useful: [num1, num2],
            distracting: useDistractor ? [distractor] : []
        },
        solution: {
            answer: sum,
            operation: `${num1} + ${num2} = ${sum}`,
            operationType: 'sum'
        }
    };
}

/**
 * Genera un problema de resta
 */
function generateSubtractionProblem(range, context, level) {
    let num1 = randomInRange(range.min, range.max);
    let num2 = randomInRange(range.min, range.max);

    if (num1 < num2) {
        [num1, num2] = [num2, num1];
    }

    const difference = num1 - num2;
    const useDistractor = level !== 'beginner';
    const distractor = useDistractor ? randomInRange(range.min, range.max) : null;

    // Obtener objeto del contexto balanceado
    const selectedObj = getBalancedContextObject(context.id);

    // Usar narrativas contextuales (siempre disponible desde contextualNarratives.js)
    if (typeof generateContextualNarrative !== 'undefined') {
        const mathData = { num1, num2, distractor, answer: difference };
        const lang = typeof currentLanguage !== 'undefined' ? currentLanguage : 'es-ES';
        const narrative = generateContextualNarrative(mathData, 'resta', context.id, level, selectedObj, lang);

        return {
            statement: {
                'es-ES': narrative.story_text,
                'en-GB': narrative.story_text
            },
            question: narrative.question,
            data: {
                useful: [num1, num2],
                distracting: useDistractor ? [distractor] : []
            },
            solution: {
                answer: difference,
                operation: `${num1} - ${num2} = ${difference}`,
                operationType: 'subtraction'
            }
        };
    }

    // Fallback ultra-básico (solo si contextualNarratives.js no está cargado)
    const contextObj = getBalancedContextObject(context.id);
    const lang = (typeof currentLanguage !== 'undefined' ? currentLanguage : 'es-ES') === 'es-ES' ? 'es' : 'en';
    const objPlural = contextObj.plural[lang];

    return {
        statement: {
            'es-ES': `Había ${num1} ${objPlural} y se retiran ${num2} ${objPlural}.`,
            'en-GB': `There were ${num1} ${objPlural} and ${num2} ${objPlural} are removed.`
        },
        question: `¿Cuántos ${objPlural} quedan?`,
        data: {
            useful: [num1, num2],
            distracting: useDistractor ? [distractor] : []
        },
        solution: {
            answer: difference,
            operation: `${num1} - ${num2} = ${difference}`,
            operationType: 'subtraction'
        }
    };
}


/**
 * Genera un número aleatorio en un rango
 */
function randomInRange(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

// Exportar funciones
if (typeof module !== 'undefined' && module.exports) {
    module.exports = {
        generateProblems,
        generateSingleProblem,
        generateSumProblem,
        generateSubtractionProblem
    };
}

// Exportar al objeto window para uso en navegador
if (typeof window !== 'undefined') {
    window.CONTEXT_CONTAINERS = CONTEXT_CONTAINERS;
    window.CONTEXT_OBJECTS = CONTEXT_OBJECTS; // Exportar para debugging
    window.getBalancedContextObject = getBalancedContextObject;
    window.resetObjectUsageTracking = resetObjectUsageTracking;
    window.objectUsageCount = objectUsageCount; // Para análisis
    window.generateProblems = generateProblems;
    window.generateSingleProblem = generateSingleProblem;
    window.generateSumProblem = generateSumProblem;
    window.generateSubtractionProblem = generateSubtractionProblem;
}

console.log('✅ [ProblemGenerator] Sistema de generación de problemas cargado');
